import React, { useState, useRef } from "react";
import { Container, FloatingLabel } from "react-bootstrap";
import axios from 'axios';

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Captcha from '../../component/Captcha'
import { Modal } from "react-bootstrap";

import "../contactus/ContactUs.css";
import backgroundImage from "../../assets/images/slide2.jpeg";
import { Helmet } from "react-helmet";
import { FaCheckCircle, FaEnvelope, FaWhatsapp } from "react-icons/fa"

const ContactUS = () => {
  const [captchaInput, setCaptchaInput] = useState('');
  const [captchaValue, setCaptchaValue] = useState('');
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleCaptchaChange = (value) => {
    setCaptchaInput(value);
  };
  const handleCaptchaReset = () => {
    setResetCaptcha(true);
  };

  const sectionStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundColor: "#a20000",
    backgroundBlendMode: "multiply",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "250px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  const [checkboxValues, setCheckboxValues] = useState({
    moreThan500: false,
    from100To500: false,
    from10To100: false,
    from1To10: false,
    lessThan1: false,
    somethingElse: false,
  });

  const formRef = useRef();
  const [showModal, setShowModal] = useState(false);

  const handleCheckboxChange = (checkboxName) => {
    setCheckboxValues((prevValues) => ({
      ...prevValues,
      [checkboxName]: !prevValues[checkboxName],
    }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (captchaInput === captchaValue) {
      // setIsValid(true);
      alert('CAPTCHA Verified!');
      setLoading(true);

      try {
        const formData = new FormData(formRef.current);

        // Append checkbox values to formData
        Object.entries(checkboxValues).forEach(([key, value]) => {
          formData.append(key, value ? 'Yes' : 'No');
        });

        let utm = localStorage.getItem('utm_data') || null;
        formData.append('utm', utm);

        const response = await axios.post('https://gautamsolar.us/submit-contactus', Object.fromEntries(formData));

        // const response = await axios.post('http://localhost:1008/submit-contactus', Object.fromEntries(formData));


        if (response?.data?.success) {
          
          setLoading(false);
          formRef.current.reset();
          localStorage.removeItem('utm_data');
        }

        setShowModal(true);
        handleCaptchaReset();
      } catch (error) {
        setLoading(false);
        console.error('Error sending email:', error);
      }
    } else {
      // setIsValid(false);
      alert('CAPTCHA Verification Failed! Please try again.');
    }
  };


  return (
    <>
      <Helmet>
        <title>Solar Panel Manufacturer</title>
        <meta name="description" content="Need a reliable solar panel manufacturer? Gautam Solar combines 28+ years of industry expertise with four advanced factories in Haridwar and Bhiwani. They deliver high-efficiency Mono PERC and N‑Type TOPCon modules (up to 23.7%), globally certified, with AI-enhanced quality control and strong warranties. " />

        <meta name="keywords" content="Solar Panel Manufacturer, best solar company,  India Solar Manufacturer company, solar panel manufacturers in india" />

        <link rel="canonical" href="https://gautamsolar.com/contactus/" />
      </Helmet>

      <h1 className="sr-only">Contact Us</h1>

      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-d29e141 elementor-section-full_width elementor-section-stretched elementor-section-height-default elementor-section-height-default"
        data-id="d29e141"
        data-element_type="section"
        data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;stretch_section&quot;:&quot;section-stretched&quot;}"
        style={{ ...sectionStyle }}
      >
        <div className="elementor-background-overlay"></div>
        <Container className="elementor-container elementor-column-gap-no">
          <Row className="elementor-row">
            <Col
              className="elementor-column elementor-col-12 elementor-top-column elementor-element elementor-element-0a1c64f"
              data-id="0a1c64f"
              data-element_type="column"
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <div
                    className="elementor-element elementor-element-b12b60d elementor-widget elementor-widget-modina_section_title"
                    data-id="b12b60d"
                    data-element_type="widget"
                    data-widget_type="modina_section_title.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="block-contents text-center">
                        <h2 className="resText">Contact Us</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Container fluid>

        <div className="bg-color border rounded my-5">
          <Form ref={formRef} onSubmit={sendEmail}>
            <Row className="mb-4">
              <Col md="6" lg="3">
                <Form.Control
                  required
                  type="text"
                  placeholder="Name*"
                  name="name"
                  aria-label="Name"
                />
              </Col>
              <Col md="6" lg="3">
                <Form.Control
                  required
                  type="text"
                  placeholder="Mobile No*"
                  name="phone"
                  aria-label="Mobile Number"
                />
              </Col>
              <Col md="6" lg="3">
                <Form.Control
                  required
                  type="text"
                  placeholder="Email*"
                  name="email"
                  aria-label="Email"
                />
              </Col>
              <Col md="6" lg="3">
                <Form.Control
                  required
                  type="text"
                  placeholder="City*"
                  name="city"
                  aria-label="City"
                />
              </Col>
            </Row>
            <Row>
              <Col md="12" lg="8">
                <div className="border py-3 px-2 rounded d-flex align-items-center  bg-light">
                  <div className="">
                    <div className="box__label--rotate">
                      <h5>CONTACT US</h5>
                    </div>
                  </div>
                  <div className="p-1">
                    <div className="text-center cheak-boxHeading">
                      <h5 className="border-bottom">
                        How Many MWp Required?*
                      </h5>
                    </div>
                    <div className="row">
                      <Col md="6">
                        <Form.Group className="mb-3">
                          <Form.Check
                            label="More than 500 MWp"
                            onChange={() => handleCheckboxChange("moreThan500")}
                            id="moreThan500"
                            name="mwpCheckbox"
                          />
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className="mb-3">
                          <Form.Check
                            label="100 MWp to 500 MWp"
                            onChange={() => handleCheckboxChange("100 MWp to 500 MWp")}
                            id="from100To500"
                            name="mwpCheckbox"
                          />
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className="mb-3">
                          <Form.Check
                            label="10 MWp to 100 MWp"
                            onChange={() => handleCheckboxChange("10 MWp to 100 MWp")}
                            id="from10To100"
                            name="mwpCheckbox"
                          />
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className="mb-3">
                          <Form.Check
                            label="1 MWp to 10 MWp"
                            onChange={() => handleCheckboxChange("1 MWp to 10 MWp")}
                            id="from1To10"
                            name="mwpCheckbox"
                          />
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className="mb-3">
                          <Form.Check
                            label="Less than 1 MWp"
                            onChange={() => handleCheckboxChange("Less than 1 MWp")}
                            id="lessThan1"
                            name="mwpCheckbox"
                          />
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className="mb-3">
                          <Form.Check
                            label="I want Something else"
                            onChange={() => handleCheckboxChange("I want Something else")}
                            id="somethingElse"
                            name="mwpCheckbox"
                          />
                        </Form.Group>
                      </Col>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md="12" lg="4">
                <div className="border rounded h-100 bg-light">
                  <div className="p-2">
                    <FloatingLabel controlId="floatingTextarea2" label="Remark*">
                      <Form.Control
                        as="textarea"
                        placeholder="Leave a comment here"
                        style={{ height: "150px", resize: 'none' }}
                        name="remark"
                        required
                      />
                    </FloatingLabel>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="text-center mt-4 p-1 border-top" >
              <Captcha
                captchaValue={captchaValue}
                setCaptchaValue={setCaptchaValue}
                handleCaptchaChange={handleCaptchaChange}
                resetCaptcha={resetCaptcha}
                setResetCaptcha={setResetCaptcha}
              />

              <Button

                style={{ backgroundColor: "#a20000", color: "#ffffff" }}
                type="submit"
                variant="danger"
                disabled={loading}
              >
                {loading ?
                  <div className="spinner-border text-white" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  :
                  'Submit'
                }
              </Button>

            </div>
          </Form>
        </div>



        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton style={{ backgroundColor: "#f8f9fa" }}>
            <Modal.Title style={{ fontWeight: "bold", color: "#a20000", display: "flex", alignItems: "center", gap: "10px" }}>
              <FaCheckCircle size={24} />
              Thank You!
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: "20px", fontSize: "16px", color: "#333" }}>
            <p style={{ marginBottom: "12px" }}>
              Your form has been <strong>submitted successfully</strong>!
            </p>
            <p style={{ marginBottom: "16px" }}>
              <strong>Thank you for connecting with us.</strong><br />
              We’ll reach out to you soon.
            </p>

            <div style={{
              backgroundColor: "#f1f1f1",
              padding: "12px 16px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              gap: "10px"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <FaEnvelope style={{ color: "#a20000" }} />
                <a href="mailto:info@gautamsolar.com" style={{ color: "#a20000", textDecoration: "none" }}>
                  info@gautamsolar.com
                </a>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <FaWhatsapp style={{ color: "#a20000" }} />
                <a href="https://wa.me/9311797248" target="_blank" rel="noopener noreferrer" style={{ color: "#a20000", textDecoration: "none" }}>
                  9311797248
                </a>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer style={{ backgroundColor: "#f8f9fa" }}>
            <Button style={{backgroundColor:'#a20000'}} onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

      
      </Container>
    </>
  );
};

export default ContactUS;
